import BaseQuestionModel from '../BaseQuestionModel'
import { IQuestionModelConstructor, QuestionType, SubQuestionID } from '../types'
import {
  PolarityScaleQuestionModelTypes,
  IPolarityScaleQuestionModelState,
  IPolarityScaleResponseValidation,
  PolarityScaleSubmitResponse,
  PolarityScaleResponse
} from './types'

const PolarityScaleQuestionModel: IQuestionModelConstructor<PolarityScaleQuestionModelTypes> = (
  questionSchema,
  action
) => {
  const { model } = BaseQuestionModel<PolarityScaleQuestionModelTypes, IPolarityScaleQuestionModelState>({
    questionType: QuestionType.POLARITY_SCALE,
    questionSchema: questionSchema,
    action,
    submitResponse,
    initState,
    validateResponse
  })
  return model
}

function submitResponse({ response, questionSchema }: IPolarityScaleQuestionModelState) {
  return response.data.reduce((acc: PolarityScaleSubmitResponse, item, i) => {
    if (item.hidden) return acc
    if ('sliders' == questionSchema.slider_type) {
      if (item.v > 0) acc.push({ id: questionSchema.matrix_batches[i].answers[1].id, v: item.v })
      else acc.push({ id: questionSchema.matrix_batches[i].answers[0].id, v: -item.v })
    } else {
      const domain = questionSchema.domain || questionSchema.matrix_batches[i].answers[0].domain[1]
      if (item.v > domain) acc.push({ id: questionSchema.matrix_batches[i].answers[1].id, v: item.v - domain })
      else acc.push({ id: questionSchema.matrix_batches[i].answers[0].id, v: domain - item.v })
    }

    return acc
  }, [])
}

function initState(state: IPolarityScaleQuestionModelState): IPolarityScaleQuestionModelState {
  state.response = {
    data: state.questionSchema.matrix_batches.map<PolarityScaleResponse['data'][number]>(batch => {
      return { id: batch.id, v: null }
    }),
    valid: false
  }
  return state
}

function validateResponse({
  response,
  questionSchema
}: IPolarityScaleQuestionModelState): IPolarityScaleResponseValidation {
  if (!response.data.length)
    return {
      valid: true
    }

  const invalidBatches: SubQuestionID[] = []
  response.data.forEach(item => {
    if (
      (null === item.v || (!item.v && !questionSchema.accept_neutral && 'sliders' == questionSchema.slider_type)) &&
      !item.hidden
    )
      invalidBatches.push(item.id)
  })

  return {
    valid: !response.data.some(
      item =>
        (null === item.v && !item.hidden) ||
        (!item.v && !item.hidden && !questionSchema.accept_neutral && 'sliders' == questionSchema.slider_type)
    ),
    invalidBatches: invalidBatches
  }
}

export default PolarityScaleQuestionModel
